import { useReservations } from './useReservations';
export function useHasActiveReservations(isLoggedIn) {
    const { reservations, loadingReservations } = useReservations({ status: 'active' }, undefined, {
        enabled: isLoggedIn,
    });
    return {
        hasActiveReservations: reservations.length > 0,
        loadingActiveReservations: loadingReservations,
    };
}
